export default __webpack_public_path__ + "static/media/UtkarshYadav.5de3879f.jpg";